import PropTypes from 'prop-types';
import * as Styled from './Box.styles';
import { Label } from '../Label/Label';

export const Box = ({ title, helperTitle, helperMessage, children }) => {
  return (
    <Styled.Card>
      {title && <Label helperTitle={helperTitle} helperMessage={helperMessage}>{title}</Label>}
      {children}
    </Styled.Card>
  );
};

Box.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
};
